exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accept-analysis .header[data-v-1ca8d940]{margin:20px}.accept-analysis .content .chart[data-v-1ca8d940]{width:500px;margin:0 auto;height:400px}\n", ""]);

// exports
